module.exports = __webpack_public_path__ + "img/hero-background.e3b75882.svg";